const initialState = {
    copyingChallenge: false,
    copyChallengeFormSubmitted: false,
    createdChallengeId: null,
    error: null
};

export default initialState;



// WEBPACK FOOTER //
// ./public/pages/BreakCopy/initialState.js